export default __webpack_public_path__ + "static/8-of-the-best-cruises-in-the-world-9a0f56ad10c3766c9485e8dd51c337db.jpg";